import React, { useState } from 'react';
import MenuContext from './MenuContext';

const MenuBar = ({ children }) => {
    const menuHook = useState('');
    return <MenuContext.Provider value={menuHook}>{children}</MenuContext.Provider>;
};

export default MenuBar;
